import { render, staticRenderFns } from "./approvalData.vue?vue&type=template&id=bb287aaa&scoped=true&"
import script from "./approvalData.vue?vue&type=script&lang=js&"
export * from "./approvalData.vue?vue&type=script&lang=js&"
import style0 from "./approvalData.vue?vue&type=style&index=0&id=bb287aaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb287aaa",
  null
  
)

export default component.exports